import { z } from 'zod';

export enum AdmDocumentType {
  PHOTO = 'PHOTO',
  CURRICULM_VITATE = 'CURRICULM_VITATE',
  IDENTITY_CARD = 'IDENTITY_CARD',
  DIPLOMA = 'DIPLOMA',
  LAST_SCHOOL_REPORT = 'LAST_SCHOOL_REPORT',
  CERTIFICATE_EXAMS_EXAMS_TAKEN_AMD_STUDY_PLAN = 'CERTIFICATE_EXAMS_EXAMS_TAKEN_AMD_STUDY_PLAN',
  DEGREE_CERTIFICATE_IF_ALREADY_GRADUATED = 'DEGREE_CERTIFICATE_IF_ALREADY_GRADUATED',
  DEGREE_CERTIFICATE = 'DEGREE_CERTIFICATE',
  LETTER_OF_ADMISSION_TO_DOCTORATE = 'LETTER_OF_ADMISSION_TO_DOCTORATE',
  CERTIFICATE_OF_ENROLLMENT = 'CERTIFICATE_OF_ENROLLMENT',
  TRANSCRIPT_OF_RECORDS_AND_DEGREE_CERTIFICATE = 'TRANSCRIPT_OF_RECORDS_AND_DEGREE_CERTIFICATE',
  STUDY_PLAN = 'STUDY_PLAN',
  DIPLOMA_SUPPLEMENT = 'DIPLOMA_SUPPLEMENT',
  ISEE = 'ISEE',
  DSU = 'DSU',
}
export enum ResidenceMode {
  FIRST_ENROLLMENT = 'FIRST_ENROLLMENT',
  ALREADY_ENROLLED = 'ALREADY_ENROLLED',
  GRADUATED = 'GRADUATED',
  INTERNATIONAL = 'INTERNATIONAL',
}

export const requiredDocumentSchema = z.object({
  key: z.nativeEnum(AdmDocumentType),
  required: z.boolean().default(false),
  content: z.object({
    it: z.string(),
    en: z.string(),
  }),
  order: z.number().default(0),
});
export type RequiredDocumentType = z.TypeOf<typeof requiredDocumentSchema>;

export type IResidence = {
  _id: string;
  name: string;
  emails: string[];
  createdAt: Date;
  updatedAt: Date;
  promoCodeEnabled?: boolean;
  admRequiredDocuments: RequiredDocumentType[];
  mode: ResidenceMode;
};
